import { useFetch } from "../../helpers/useFetch.js";
import { useLoaderData } from "react-router-dom";
import useTitle from "../../hooks/useTitle.js";
import Page from "../../components/layout/Page.jsx";
import ContractsTable from "../../components/table/ContractsTable.jsx";
import InfectiousnessBlocks from "../../components/users/InfectiousnessBlocks.jsx";
import { useState } from "react";
import { Button, Group, Paper, Text } from "@mantine/core";
import { IconCheck, IconEye, IconSignature } from "@tabler/icons-react";
import { toast } from "react-hot-toast";
import TaxDeclarationSign from "../../components/user/TaxDeclarationSign.jsx";

export async function loader() {
  const [contractsRes, taxRes] = await Promise.all([useFetch("user/contracts"), useFetch("user/tax-declaration")]);
  return { contracts: contractsRes.data, taxDeclaration: taxRes };
}

export default function ContractsPage() {
  const { contracts, taxDeclaration: initialTaxDeclaration } = useLoaderData();
  const [taxDeclaration, setTaxDeclaration] = useState(initialTaxDeclaration);
  const [signOpened, setSignOpened] = useState(false);
  const [signLoading, setSignLoading] = useState(false);

  useTitle("Mé smlouvy");

  const handleSign = async (svg, months) => {
    setSignLoading(true);
    const res = await useFetch("/user/tax-declaration/sign", "POST", { svg, months });
    if (res.status === "ok") {
      setTaxDeclaration({ signed: true, year: new Date().getFullYear().toString(), filePath: res.filePath });
      setSignOpened(false);
      toast.success("Prohlášení o dani úspěšně podepsáno.");
    } else {
      toast.error(res.error || "Nastala chyba při podpisu.");
    }
    setSignLoading(false);
  };

  return (
    <>
      <Page title="Mé smlouvy">
        <div className="flex flex-col gap-2">
          <InfectiousnessBlocks blocks={""} />

          <Paper withBorder p="md" radius="md">
            <Text fw={600} mb="xs">
              Prohlášení poplatníka daně z příjmů
            </Text>
            {taxDeclaration.signed ? (
              <Group gap="sm">
                <IconCheck size={18} stroke={1.5} className="text-teal-500" />
                <Text size="sm" c="dimmed">
                  Podepsáno pro rok {taxDeclaration.year}
                </Text>
                {taxDeclaration.filePath && (
                  <Button
                    component="a"
                    href={taxDeclaration.filePath}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="light"
                    size="xs"
                    leftSection={<IconEye size={14} stroke={1.5} />}>
                    Zobrazit dokument
                  </Button>
                )}
              </Group>
            ) : (
              <Button
                size="sm"
                leftSection={<IconSignature size={18} stroke={1.5} />}
                onClick={() => setSignOpened(true)}>
                Podepsat prohlášení
              </Button>
            )}
          </Paper>

          <ContractsTable contracts={contracts} myContracts />
        </div>
      </Page>
      {signOpened && (
        <TaxDeclarationSign onClose={() => setSignOpened(false)} onSign={handleSign} loading={signLoading} />
      )}
    </>
  );
}
